// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__TWZUG","Error":"Input_Error__Cdmo6"};